<template>
  <Card class="full-height">
    <TabSet ref="tabSet" tab-set-id="contents_tab_set">
      <Tab v-for="(channel, index) in selectedChannels" :label="$t(`channels.${channel}`)" :key="channel" :position="index + ''" tab-set-id="contents_tab_set" :ref="`tab_${channel}`">
        <CallContentSettings v-if="channel === 'call'" :editable="isCreate || isEdit" ref="content_call" :value="call" />
        <EmailContentSettings v-if="channel === 'email'" :editable="isCreate || isEdit" ref="content_email" :value="email" />
        <PaperContentSettings v-if="channel === 'document'" :editable="isCreate || isEdit" ref="content_document" :value="document" />
        <SMSContentSettings v-if="channel === 'sms'" :editable="isCreate || isEdit" ref="content_sms" :value="sms" />
      </Tab>
    </TabSet>
  </Card>
</template>
<script>
import _ from 'lodash'
import CallContentSettings from './content-selection/CallContentSettings'
import EmailContentSettings from './content-selection/EmailContentSettings'
import PaperContentSettings from './content-selection/PaperContentSettings'
import SMSContentSettings from './content-selection/SMSContentSettings'
import Card from '../../../slds/Card'
import HasMode from '../../../utils/HasMode'
import Tab from '../../../slds/tabs/Tab'
import TabSet from '../../../slds/tabs/TabSet'
import { mapGetters } from 'vuex'
export default {
  mixins: [HasMode],
  components: {
    CallContentSettings,
    Card,
    EmailContentSettings,
    PaperContentSettings,
    SMSContentSettings,
    Tab,
    TabSet
  },
  props: {
    mode: String
  },
  data () {
    return {
      call: {},
      config: {},
      document: {},
      email: {},
      sms: {}
    }
  },
  methods: {
    callLoadFromStore () {
      const currentCampaign = _.cloneDeep(this.$store.getters['campaignDesigner/state'].currentCampaign)
    },
    getSectionToSave () {
      const configObject = {}
      const refs = this.$refs

      if (refs.content_call && refs.content_call.length > 0) {
        configObject.call = _.cloneDeep(refs.content_call[0].getSectionToSave())
      }
      if (refs.content_document && refs.content_document.length > 0) {
        configObject.document = {
          templates: {
            selected: _.cloneDeep(refs.content_document[0].getSectionToSave())
          }
        }
      }
      if (refs.content_sms && refs.content_sms.length > 0) {
        configObject.sms = _.cloneDeep(refs.content_sms[0].getSectionToSave())
      }
      if (refs.content_email && refs.content_email.length > 0) {
        configObject.email = {
          templates: {
            selected: _.cloneDeep(refs.content_email[0].getSectionToSave())
          }
        }
      }

      return {
        config: configObject
      }
    },
    validate () {
      return Object.entries(this.$refs)
        .filter(([key, value]) => key.startsWith('content_'))
        .filter(([_, component]) => component.length > 0)
        .map(([name, component]) => {
          if (component[0].validate) {
            const valid = component[0].validate()
            const [prefix, channel] = name.split('_')
            const id = this.$refs[`tab_${channel}`][0].tabId
            this.$refs.tabSet.setErrorTab(id, !valid)
            return valid
          }
        })
        .every(v => !!v)
    }
  },
  activated () {
    const config = this.$store.getters["campaignDesigner/state"].currentCampaign.config
    this.config = config
    const { contentSelection } = config
    Object.entries(contentSelection).forEach(([key, value]) => {
      this.$data[key] = _.cloneDeep(value)
    })

    Object.entries(this.$refs)
      .filter(([name, _]) => name.startsWith('tab_'))
      .filter(([_, component]) => component.length > 0)
      .forEach(([name, component]) => {
        const { tabId } = component[0]
        this.$refs.tabSet.setErrorTab(tabId, false)
      })

    this.$nextTick(() => {
      this.$refs.tabSet.setActiveTab(0)
    })
  },
  computed: {
    selectedChannels () {
      return Object.keys(this.config.contentSelection || {})
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
